import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import BlockSetupInput from './BlockSetupInput';
import BlockSetupCustomSteps from '../BlockSetupCustomSteps';
import { findField, parseFields } from './DragDropHelpers';
import { getLoadedActions } from '../../../helpers/applications';


class ArrayInput extends Component {

    state = {
        items: [],
        newKey: 0,
        isSimpleType: false
        //properties : {}
    }

    constructor() {
        super()
        this.addItem = this.addItem.bind(this)
        this.removeItem = this.removeItem.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    componentDidMount() {

    }

    static getDerivedStateFromProps(props, state) {
        if (props.itemType["$ref"] || props.itemType["typeprefix"]) {
            state.isSimpleType = false
        } else {
            state.isSimpleType = true
        }
        if (state.value !== props.value) {
            state.value = props.value
            if (state.items.length == 0) {
                const keyPrefixLength = (props.step.id + ".item_").length
                Object.entries(props.value).forEach(([key, values]) => {
                    state.items.push({
                        "id": "fields",
                        "type": "custom",
                        "label": "Fields",
                        "key": key,
                        "fields": props.step.id
                    })
                    var intKey = parseInt(key.substring(keyPrefixLength))
                    if (intKey >= state.newKey) {
                        state.newKey = intKey + 1
                    }
                })
            }
        } else {
            if (state.items.length == 0) {//} && props.step.popular && !props.value) {
                state.items.push({
                    "id": "fields",
                    "type": "custom",
                    "label": "Fields",
                    "key": props.step.id + ".item_0",
                    "fields": props.step.id
                })
                state.newKey++
            }
        }
        return state
    }

    addItem() {
        let items = this.state.items
        items.push({
            "id": "fields",
            "type": "custom",
            "label": "Fields",
            "key": this.props.step.id + ".item_" + this.state.newKey,
            "fields": this.props.step.id
        })

        this.setState({ items, newKey: this.state.newKey + 1 })
    }

    removeItem(e) {
        const itemKey = e.target.dataset.key
        //const itemKey = this.props.step.id + ".item_" + e.target.dataset.key
        let items = this.state.items
        const index = items.findIndex(item => item.key === itemKey);
        items.splice(index, 1);
        this.setState(({ items }))

        if (this.props.value) {
            let properties = this.props.value
            delete properties[itemKey]
            this.props.onChange(properties)
        }
    }

    onChange(stepId, property) {
        let properties = this.props.value ? this.props.value : {}
        properties[stepId] = this.state.isSimpleType ? property[this.props.step.id + "[]"] : property
        this.props.onChange(properties)
        //this.props.onChange(property)
    }

    render() {
        const { t } = this.props;

        let items = []
        for (let i = 0; i < this.state.items.length; i++) {
            const item = this.state.items[i];

            //TODO: Other types? CAn we move that to input?
            let parameters, fields
            // const key = this.props.step.id + ".item_" + i
            // //item.key = key
            const key = item.key
            if (this.props.itemType["$ref"]) {
                fields = this.props.itemType["$ref"]
            } else if (this.props.itemType["typeprefix"]) {
                if (this.props.block.params &&
                    this.props.block.params.fields &&
                    this.props.block.params.fields[item.fields] &&
                    this.props.block.params.fields[item.fields][key]) {
                    const params = this.props.block.params.fields[item.fields][key]
                    let dataType
                    if (params.field) {
                        const paramFields = parseFields(params.field.field)
                        if (paramFields && paramFields.length > 0) {
                            const p = paramFields[0]
                            const type = this.props.inputTypes.find(a => a.id == p.typeId)
                            if (type) {
                                const field = findField(type, p.id)
                                if (field.enum) {
                                    dataType = "enum"
                                    const typeId = this.props.itemType["typeprefix"] + "enum"
                                    //Get the type and replacing it enum values
                                    let genericType = getLoadedActions(this.props.block.application).types[typeId]
                                    //TODO: [Clone]
                                    genericType = JSON.parse(JSON.stringify(genericType))
                                    let genericTypeField = findField(genericType, "value")
                                    genericTypeField.enum = field.enum
                                    ///ERRRRRRRRORO fields = genericTypeField
                                }
                            }
                            if (!dataType) {
                                dataType = p["dataType"]
                            }
                            if (!dataType) {
                                dataType = p.dataType
                            }
                        }
                    } else {
                        dataType = params.dataType
                    }
                    if (!dataType) {
                        dataType = ""
                    }
                    if (!fields) {
                        fields = this.props.itemType["typeprefix"] + dataType
                        if (!this.props.block.application || !getLoadedActions(this.props.block.application).types[fields]) {
                            fields = this.props.itemType["typeprefix"]
                        }
                    }
                } else if (this.props.block.params &&
                    this.props.block.params.inputs &&
                    this.props.block.params.inputs[item.fields] &&
                    this.props.block.params.inputs[item.fields][key]) {
                    const params = this.props.block.params.inputs[item.fields][key]
                    let dataType
                    if (params.input) {
                        const paramFields = parseFields(params.inputs.input)
                        if (paramFields && paramFields.length > 0) {
                            const p = paramFields[0]
                            dataType = p["datatype"]
                        }
                    } else {
                        dataType = params.datatype
                    }
                    if (!dataType) {
                        dataType = ""
                    }
                    if (!fields) {
                        fields = this.props.itemType["typeprefix"] + dataType
                        if (!this.props.block.application || !getLoadedActions(this.props.block.application).types[fields]) {
                            fields = this.props.itemType["typeprefix"]
                        }
                    }
                } else {
                    fields = this.props.itemType["typeprefix"]
                }
            } else {
                fields = [{
                    type: this.props.itemType.type,
                    description: this.props.itemType.description,
                    preferred: true,
                    required: true,
                    label: " ",
                    id: this.props.step.id + "[]"
                }]
            }
            let value = this.state.value ? this.state.value[item.key] : this.state.value
            if (this.state.isSimpleType) {
                const valueKey = this.props.step.id + "[]"
                var newValue = {}
                newValue[valueKey] = value
                value = newValue
            }

            items.push(
                <table key={key}><tbody><tr>
                    <td width="30" style={{ verticalAlign: "top" }}>
                        {this.state.items.length > 1 ? <button
                            className="icon-button field-add-button"
                            title={t("tip_remove_item")}
                            style={{ "top": "0px" }}
                            onClick={(e) => this.removeItem(e)}
                        ><i className="fas fa-minus" data-key={item.key}></i></button> : ""}
                    </td><td>
                        <BlockSetupCustomSteps parameters={parameters} fields={fields} block={this.props.block} onChange={this.onChange} value={value} inputTypes={this.props.inputTypes} stepId={key} accountId={this.props.accountId} />
                    </td></tr></tbody></table>)
        }
        return <div>
            {items}
            <button
                className="icon-button field-add-button"
                title={t("tip_add_item")}
                style={{ "top": "0px", "bottomMargin": "10px" }}
                onClick={() => this.addItem()}
            ><i className="fas fa-plus"></i></button>
        </div>
    }
}

export default withTranslation()(ArrayInput)